import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.korslovo.category.item');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU } from "src/libs/portal/korslovo/i18n";

@Component({
    selector: 'wiz-page-korslovo-category-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.korslovo.category.item/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: auto;
}`],
})
export class PageKorslovoCategoryItemComponent implements OnInit {
    public ru = RU;
    public loading: boolean = true;
    public category: any = {};
    public lessons: any[] = [];
    public categoryId: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.categoryId = WizRoute.segment.id;
        if (!this.categoryId) {
            this.service.href('/category');
            return;
        }
        await this.loadData();
    }

    public async loadData() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("lessons", { category_id: this.categoryId });
        if (code === 200) {
            this.category = data.category || {};
            this.lessons = data.lessons || [];
        }

        this.loading = false;
        await this.service.render();
    }

    public goBack() {
        this.service.href('/category');
    }

    public goLesson(lesson: any) {
        this.service.href(`/learn/${lesson.id}`);
    }

    public goQuiz(lesson: any) {
        this.service.href(`/quiz/${lesson.id}/choice`);
    }

    public goCrossword(lesson: any) {
        this.service.href(`/crossword/${lesson.id}`);
    }

    public statusLabel(status: string): string {
        if (status === 'completed') return this.ru.lesson_completed;
        if (status === 'in_progress') return this.ru.lesson_in_progress;
        return this.ru.lesson_not_started;
    }

    public statusColor(status: string): string {
        if (status === 'completed') return 'bg-emerald-100 text-emerald-700';
        if (status === 'in_progress') return 'bg-blue-100 text-blue-700';
        return 'bg-zinc-100 text-zinc-500';
    }

    public actionLabel(status: string): string {
        if (status === 'in_progress') return this.ru.lesson_continue;
        return this.ru.lesson_start;
    }

    public catBadgeBg(): string {
        if (!this.lessons.length) return 'bg-zinc-300';
        const completed = this.lessons.filter((l: any) => l.progress_status === 'completed').length;
        const allMastered = this.lessons.every((l: any) => this.masteryLevel(l) >= 3);
        if (allMastered && completed >= this.lessons.length) return 'bg-amber-500';
        if (completed >= this.lessons.length) return 'bg-emerald-700';
        if (completed > 0) return 'bg-emerald-500';
        return 'bg-zinc-300';
    }

    public masteryLevel(lesson: any): number {
        const modes = lesson.completed_modes || '';
        if (!modes) return 0;
        return modes.split(',').filter((m: string) => m).length;
    }

    public masteryStars(lesson: any): { filled: number; empty: number; isGold: boolean } {
        const level = this.masteryLevel(lesson);
        return {
            filled: level,
            empty: 3 - level,
            isGold: level >= 3
        };
    }
}

export default PageKorslovoCategoryItemComponent;